import React from 'react'

const Gallery = ({
  fill = 'black',
  width
}: {
  fill?: string
  width?: string
}) => (
  <svg
    width={width || '24px'}
    height={width || '24px'}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6667 14.3333C26.6667 13.781 26.219 13.3333 25.6667 13.3333L22.3334 13.3333C21.7811 13.3333 21.3334 13.781 21.3334 14.3333L21.3334 17.6666C21.3334 18.2189 21.7811 18.6666 22.3334 18.6666L25.6667 18.6666C26.219 18.6666 26.6667 18.2189 26.6667 17.6666L26.6667 14.3333ZM26.6667 7.66659C26.6667 7.1143 26.219 6.66658 25.6667 6.66658L22.3334 6.66658C21.7811 6.66658 21.3334 7.1143 21.3334 7.66658L21.3334 10.9999C21.3334 11.5522 21.7811 11.9999 22.3334 11.9999L25.6667 11.9999C26.219 11.9999 26.6667 11.5522 26.6667 10.9999L26.6667 7.66659ZM26.6667 20.9999C26.6667 20.4476 26.219 19.9999 25.6667 19.9999L22.3334 19.9999C21.7811 19.9999 21.3334 20.4476 21.3334 20.9999L21.3334 24.3333C21.3334 24.8855 21.7811 25.3333 22.3334 25.3333L25.6667 25.3333C26.219 25.3333 26.6667 24.8855 26.6667 24.3333L26.6667 20.9999ZM19.0001 25.3333C19.5524 25.3333 20.0001 24.8855 20.0001 24.3333L20.0001 7.66658C20.0001 7.1143 19.5524 6.66658 19.0001 6.66658L6.33342 6.66658C5.78113 6.66658 5.33342 7.1143 5.33342 7.66658L5.33342 24.3333C5.33342 24.8855 5.78113 25.3333 6.33342 25.3333L19.0001 25.3333Z"
      fill="black"
    />
  </svg>
)

export default Gallery
